import React from 'react';
import MediaQuery from 'react-responsive';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { getImagesStaticUrl } from '../../../helpers';
import ReactivateTodayDisclaimer from '../ReactivateTodayDisclaimer';

import styles from './MainBanner.module.scss';

export const REACTIVATE_TITLE = 'Reactivate Your Membership';
export const REACTIVATE_DESCRIPTION =
  'Don’t miss out on fully customizing your seasonal box, access to members only sales, and other amazing membership perks.';

const MainBanner = ({ isLoading, setIsLoading, setShowRetry }) => {
  const { reactivateTodayHero } = useFlags();
  const getHeroImage = () => {
    if (!reactivateTodayHero)
      return getImagesStaticUrl('reactivate-today-box-2.jpg');
    // eslint-disable-next-line max-len
    return 'https://scontent01.fabfitfun.com/my-account/cdn/stacked-products-reactivate-today.jpg';
  };

  return (
    <section className={styles['today-main-banner']}>
      <div className={styles['today-main-banner__image-container']}>
        <img src={getHeroImage()} alt="Open box" />
      </div>
      <div className={styles['today-main-banner__title-container']}>
        <h1 className={styles['today-main-banner__title']}>
          {REACTIVATE_TITLE}
        </h1>
        <p className={styles['today-main-banner__description']}>
          {REACTIVATE_DESCRIPTION}
        </p>
        <MediaQuery minDeviceWidth={768}>
          <ReactivateTodayDisclaimer
            customStyles="mainBanner"
            isLoading={isLoading}
            setIsLoading={setIsLoading}
            setShowRetry={setShowRetry}
          />
        </MediaQuery>
      </div>
    </section>
  );
};

export default MainBanner;
